import React, { FC, memo, useMemo, useRef } from 'react'
import s from './RestMenuItem.module.sass'
import { Text } from '@shared/ui/Typography/Text'
import { TypeMenuItem } from '@widgets/Restaurant/RestMenuItem/types/menu'
import { ErrorBoundary } from '@shared/lib/components/ErrorBoundary'
import { useIntersectionAnalytic } from '@shared/lib/hooks/useIntersectionAnalytic'
import { EGG } from '@shared/api/analytics'
import { useCurrentSize } from '@shared/lib/helpers/classes'
import { useRouter } from 'next/router'

const RestMenuItem: FC<TypeMenuItem & { className?: string }> = ({
  id,
  type,
  title,
  img,
  href,
  analytic,
  sizes,
  className = '',
}) => {
  const [currentSize] = useCurrentSize(sizes)
  const router = useRouter()
  const wrapper = useRef()
  const isDelivery = type === 'delivery'

  const link = isDelivery ? `/${router.query.city_slug}/restaurant/${router.query.rest_slug}/menu/delivery/` : href
  const description = useMemo(() => {
    if (!href && type === 'delivery') return '24 позиции'
    const m = href?.match(/\.([^.]+)$/)
    return m ? m[1].toUpperCase() : 'Формат не определен'
  }, [href, type])

  const sizesTitle = {
    '298x92': 'L',
    '261x86': 'ML',
    '245x76': 'M',
  }

  const sizesImage = {
    '298x92': 92,
    '261x86': 86,
    '245x76': 76,
  }

  const getSizeTitle = sizesTitle[currentSize]
  const getSizeImage = sizesImage[currentSize]

  useIntersectionAnalytic(wrapper, () =>
    EGG.pages.RestItem.menu_item_view({
      menu_type: title,
      object_id: id,
      object_type: 'menu',
      section_index: analytic?.section_index || 0,
    }),
  )

  const handleClickMenu = () => {
    EGG.pages.RestItem.menu_item_click({
      menu_type: title,
      object_id: id,
      object_type: 'menu',
      section_index: analytic?.section_index || 0,
    })
  }

  return (
    <ErrorBoundary>
      <a
        ref={wrapper}
        href={link}
        className={`${s.menu} ${className}`}
        target='_blank'
        rel='noreferrer'
        data-menu-item-id={id}
        data-menu-type={type}
        data-size={currentSize}
        onClick={handleClickMenu}>
        <Text sizes={getSizeTitle} className={s.title}>
          {title}
        </Text>

        <Text sizes={'S'} className={s.ext}>
          {description}
        </Text>

        <div className={s['image-wrapper']}>
          <img
            src={img || ''}
            width={getSizeImage}
            height={getSizeImage}
            className={s['image-elem']}
            alt={`Ссылка на меню — ${title}`}
          />
        </div>
      </a>
    </ErrorBoundary>
  )
}

export default memo(RestMenuItem)
